import React from 'react';

const MapKeys = () => (
  <div className="development-listing__keys">
    <div className="development-listing__key"><span className="development-listing__key-status development-listing__key-status--available"></span><span className="development-listing__key-title">Available</span></div>
    <div className="development-listing__key"><span className="development-listing__key-status development-listing__key-status--coming-soon"></span><span className="development-listing__key-title">Coming Soon</span></div>
  </div>
)

export default MapKeys;